import React from 'react';
import { Box, Theme, createStyles, makeStyles } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowsRepeat } from '@fortawesome/pro-regular-svg-icons';
import { AppointmentCountRecurrent, AppointmentDuration } from '@spike/appointment-model';

interface Props {
    duration?: AppointmentDuration;
    recurrent?: AppointmentCountRecurrent;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            'display': 'flex',
            'fontSize': 14,
            'lineHeight': '14px',
            '& > svg': {
                marginRight: 5,
                fontSize: 16,
                lineHeight: '24px'
            }
        },
        date: {
            margin: 0,
            fontSize: 16,
            fontWeight: 600,
            lineHeight: '100%',
            marginBottom: 8
        }
    })
);

const BookingRecurrencyInfo: React.FunctionComponent<Props> = ({ duration, recurrent }) => {
    const classes = useStyles();

    return (
        <>
            {recurrent?.frecuency && (
                <>
                    <p className={classes.date}>
                        {duration?.from?.format('dddd, DD MMM YYYY - hh:mmA')} - {duration?.to?.format('hh:mmA')}
                    </p>
                    <Box className={classes.root}>
                        <FontAwesomeIcon icon={faArrowsRepeat} />
                        Repeats {recurrent?.frecuency.name.toLowerCase()} until {recurrent.lastDate.format('ll')}
                    </Box>
                </>
            )}
        </>
    );
};

export default BookingRecurrencyInfo;
